import {useQuery} from "@tanstack/react-query";
import React from "react";
import {readLocationSelectBoxApi} from "../../../../../api/correspondent/CorresspondentApi";

/**
 * 소재지 셀렉트박스
 * @param props
 * @returns
 */
export const useReadLocationSelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readLocationSelect"],
        queryFn: async () => await readLocationSelectBoxApi(),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
